interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetXState {
    quickbetXData: any;
    quickbetXloading: boolean;
    quickbetXerror: ErrorResponse | null;
}


export enum QuickbetXActionTypes {
    FETCH_QUICKBET_X_DATA = "FETCH_QUICKBET_X_DATA",
    FETCH_QUICKBET_X_DATA_SUCCESS = "FETCH_QUICKBET_X_DATA_SUCCESS",
    FETCH_QUICKBET_X_DATA_ERROR = "FETCH_QUICKBET_X_DATA_ERROR",
}

export type QuickbetXAction =
    | { type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA }
    | { type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_SUCCESS; payload: any[] }
    | { type: QuickbetXActionTypes.FETCH_QUICKBET_X_DATA_ERROR; payload: any };